<template>
  <info>
    <h1>{{ $t("APIS") }}</h1>
    <h2>{{ $t("MAIN API") }}</h2>
    <p
      v-html="
        $t('WHAT_CAN_APIS_DO', {
          documentationLink:
            'https://api.dbservices.to/v1.6/spec/',
        })
      "
    ></p>
    <h2>{{ $t("STATUS_API") }}</h2>
    <p
      v-html="
        $t('STATUS_API_DESC', {
          statusLink:
            'https://status.dbservices.to/API/v1.0/spec/',
        })
      "
    ></p>
    <h2>{{ $t("DIRECT INSTALLATION SUPPORT") }}</h2>
    <p
      v-html="
        $t('DIRECT_INSTALLATION_API_DESC', {
          documentationLink:
            'https://telegra.ph/Direct-Installation-support-for-file-hosting-owners-06-19',
        })
      "
    ></p>

    <template slot="sidebar">
      <h2>{{ $t("TERMS OF USE FOR APIS") }}</h2>
      <p
        v-html="
          $t('TOS_API')
        "
      ></p>
    </template>
  </info>
</template>

<script>
import Info from '@/components/Info';

export default {
  components: { Info },
  computed: {
    title() {
      return this.$t('APIS');
    },
  },
};
</script>
